<template>
  <van-uploader
    v-model="filelist"
    upload-text="选择文件"
    multiple
    accept=""
    :max-count="maxfileAccount"
    :max-size="5242880"
    :before-read="beforeUpdate"
    :after-read="handleSelect"
    @click-preview="preview"
    @delete="deleteKeys"
    @oversize="prompt_for_oversize"
  />
</template>

<script>
import { mapActions } from 'vuex'
// import { Uploader } from 'vant'
import { upload } from '@/mixin/file'
import { loading } from '@/mixin'
import Actions from '@/constants/action'

export default {
  name: 'PwcUploadResume',
  components: {
    // Uploader
  },
  mixins: [upload, loading],
  props: {
    uploaddoclist: {
      type: Array,
      default: () => []
    },
    cvdirs: {
      type: Array,
      default: () => []
    },
    maxfcnt: {
      type: Number,
      default: () => 1
    }

  },
  data: function() {
    return {
      filelist: [],
      maxfileAccount: 1
    }
  },
  created() {
    this.filelist = this.uploaddoclist
    this.maxfileAccount = this.maxfcnt
  },
  methods: {
    ...mapActions({
      updateResume: Actions.UPDATE_RESUME
    }),
    async handleSelect(e) {
      this.loading = true
      const res = await this.uploadFile(e, '', false)
        .then(key => {
          return this.updateResume({
            item: key,
            isDelete: 0
          })
        })
      e.file.url = res.data.resumes
      this.loading = false
    },
    prompt_for_oversize: function(file) {
      this.$dialog.alert({
        message: 'File size should be less than 5M.',
        confirmButtonText: 'OK'
      }).then(() => {
      })
    },
    deleteKeys(e) {
      return this.updateResume({
        item: encodeURI(e.file.name),
        isDelete: 1
      })
    },
    beforeUpdate(e) {
      const accept = '.pdf,.doc,.docx'

      const flieArr = e.name.split('.')
      const suffix = flieArr[flieArr.length - 1] || ''

      if (!accept.includes(suffix.toLowerCase())) {
        this.$dialog.alert({
          message: '只有pdf，doc，docx格式文档允许被上传',
          confirmButtonText: 'OK'
        })
        return false
      }

      return true
    },
    preview(e) {
      if (e.file.url) {
        window.open(e.file.url)
      }
    }
  }
}
</script>
